export const NODE_ENV = process.env.REACT_APP_NODE_ENV || "development";

export const BASE_URL =
	NODE_ENV === "development"
		? "http://localhost:3000"
		: "https://www.academy-nest.com";

export const BACKEND_BASE_URL =
	NODE_ENV === "development"
		? "http://localhost:3001"
		: "https://e-learning-7rnz.onrender.com";

export const API_URL = `${BACKEND_BASE_URL}/api`;
export const DEFAULT_IMAGE_URL = "/images/default.png";
export const BASE_UPLOADS = `${API_URL}/uploads`;
